<template>
  <main id="event_body">
    <div class="myPost_wrapper end-event" id="more_board">
      <!-- title -->
      <div class="main_top">
        <h1>
          <img src="images/basic/icon/back.svg" onclick="history.back()" class="back" />
          이벤트 상세
        </h1>
      </div>
      <div class="div_padding"></div>
      <event-banner-form :bannerImg="bannerImg"></event-banner-form>
      <lotto-event-result-form :selectedList="selectedList" :bonus="bonus" :winnerList="winnerList" :winnerOpen="winnerOpen" :winnerText="winnerText" :lottoList="lottoList" :addressInputYn="addressInputYn" />
      <event-info-form :joinCnt="joinCnt" :eventTitle="eventTitle" :eventDesc="eventDesc" :eventGift="eventGift" :eventHowto="eventHowto" :eventDate="eventDate" :winnerCondition="winnerCondition" :endTime="endTime" :eventWinnerOpenDateTime="eventWinnerOpenDateTime" />
    </div>
  </main>
</template>

<script>
import $ from 'jquery';
import EventBannerForm from "./common/EventBannerForm.vue";
import EventInfoForm from "./common/EventInfoForm.vue";
import LottoEventResultForm from "./common/LottoEventResultForm.vue";
import { fetchEventDetail } from "@/api/event";
export default {
  components: {
    EventBannerForm,
    EventInfoForm,
    LottoEventResultForm,
  },
  created() {
    fetchEventDetail({
      nttId: this.$route.query.nttId,
    })
      .then(({ data }) => {
        let result = data.result;
        this.lottoList.push(`${result.num1}`, `${result.num2}`, `${result.num3}`, `${result.num4}`, `${result.num5}`, `${result.num6}`);
        this.lottoList.filter((lotto) => {
          const randNum = Math.floor(Math.random() * this.randColorList.length);
          const color = this.randColorList[randNum];
          this.selectedList.push({ num: lotto, color });
        });
        this.bonus = result.bonus;
        this.winnerList = result.winnerList;
        this.bannerImg = result.eventImage;
        this.joinCnt = result.joinCnt;
        this.eventTitle = result.eventTitle;
        this.eventDesc = result.eventDesc;
        this.eventGift = result.eventGift;
        this.eventHowto = result.eventHowto;
        this.eventDate = result.eventDate;
        this.winnerCondition = result.winnerCondition;
        this.endTime = result.endTime;
        this.winnerOpen = result.winnerOpen;
        this.winnerText = result.winnerText;
        this.addressInputYn = result.addressInputYn;
        this.eventWinnerOpenDateTime = result.eventWinnerOpenDateTime;
      })
      .then(() => {});
  },
  mounted() {
    // 배너 이미지 filter 추가
    $('.banner_img').css("filter","brightness(0.7)")
  },
  data() {
    return {
      lottoList: [],
      bonus: 0,
      winnerList: [],
      bannerImg: "",
      randColorList: ["#FBC400", "#FF7170", "#A7A2E0", "#6AC7F1", "#6DCE9D"],
      selectedList: [],
      joinCnt: 0,
      eventTitle: "",
      eventDesc: "",
      eventGift: "",
      eventHowto: "",
      eventDate: "",
      eventWinnerOpenDateTime: "",
      winnerCondition: "",
      endTime: "",
      winnerOpen: "",
      winnerText: "",
      addressInputYn: "",
    };
  },
};
</script>

<style></style>
